export default __webpack_public_path__ + "static/media/635.5bf3fe22.png";